export type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const SIZE_CONFIG: Record<Size, any> = {
  xs: {
    padding: 'px-1',
    text: 'text-xs',
    header: 'h-1',
    gap: 'gap-1'
  },
  sm: {
    padding: 'px-2 py-1',
    text: 'text-sm',
    header: 'h-1.5',
    gap: 'gap-2'
  },
  md: {
    padding: 'px-3 py-1',
    text: 'text-base',
    header: 'h-2',
    gap: 'gap-3'
  },
  lg: {
    padding: 'px-4 py-1',
    text: 'text-lg',
    header: 'h-3',
    gap: 'gap-4'
  },
  xl: {
    padding: 'px-5 py-1',
    text: 'text-xl',
    header: 'h-4',
    gap: 'gap-5'
  }
};